import OrganisationEditComponent from "screens/components/OrganisationEditComponent"

function OrganisationCreate() {
    return <OrganisationEditComponent organisationId={null} />
}

export default OrganisationCreate;